import { render, staticRenderFns } from "./UnidadeSetorDestino.vue?vue&type=template&id=62a7b3ed&"
import script from "./UnidadeSetorDestino.vue?vue&type=script&lang=js&"
export * from "./UnidadeSetorDestino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports